"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/Modals/JoinCall.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _videoRoom = require('web/selectors/videoRoom');







var _videoCall = require('web/selectors/videoCall');
var _hooks = require('web/services/hooks');

var _videoCall3 = require('web/services/videoCall');

var _videoRoom3 = require('web/services/videoRoom'); var _videoRoom4 = _interopRequireDefault(_videoRoom3);
var _JoinCall = require('web/components/VideoRooms/Room/Modals/JoinCall'); var _JoinCall2 = _interopRequireDefault(_JoinCall);

// RoomModalsScreen mounts this only while the modal is open and always passes
// the handlers (they are optional in its own props).










// memo keeps connect()'s bailout on unchanged own props.
const JoinCallModalContainer = _react.memo.call(void 0, function JoinCallModalContainer ({
  isOpen, onClose, openJoinCallModal,
  gotoSettings, gotoMeeting,
  onRoomShare, onRoomLinkCopy,
}) {
  const roomKey = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomKey)
  const roomName = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomName)
  const roomLink = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomLink)
  const isCamOn = _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamOn)
  const isMicOn = _hooks.useAppSelector.call(void 0, _videoCall.selectIsMicOn)
  const isCamCycleAvailable = _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamCycleAvailable)
  const currentCamDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId)
  const isBrowserCompatible = _hooks.useAppSelector.call(void 0, _videoCall.selectIsBrowserCompatible)
  const arePermsGranted = _hooks.useAppSelector.call(void 0, _videoCall.selectArePermsGranted)

  const [stream, setStream] = _react.useState(null)
  // Were instance fields, set on mount.
  const streamManager = _react.useRef(null)
  const videoRoomSession = _react.useRef(null)

  // componentDidMount / componentWillUnmount (class timing).
  _react.useLayoutEffect.call(void 0, () => {
    const manager = new (0, _videoCall3.StreamManager)({
      camDeviceId: currentCamDeviceId,
      useCam: true,
    })
    streamManager.current = manager

    manager
      .update({ isCamOn })
      .then(setStream)
      .catch(() => setStream(null))

    const existingSession = _videoRoom4.default.findByRoomKey(roomKey)
    if (existingSession) {
      videoRoomSession.current = existingSession
    } else {
      videoRoomSession.current = new (0, _videoRoom4.default)(roomKey)
      videoRoomSession.current.startSetup()
    }

    return () => { manager.stop() }
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- mount only, like componentDidMount
  }, [])

  // componentDidUpdate: refresh the preview when the camera or its device
  // changes. The first run only records the mount values.
  const prevCam = _react.useRef.call(void 0, { currentCamDeviceId, isCamOn })
  _react.useLayoutEffect.call(void 0, () => {
    const prev = prevCam.current
    prevCam.current = { currentCamDeviceId, isCamOn }
    if (
      prev.currentCamDeviceId !== currentCamDeviceId ||
      prev.isCamOn !== isCamOn
    ) {
      // SAFETY: the mount effect above creates the manager before this runs.
      streamManager.current.update({ isCamOn, camDeviceId: currentCamDeviceId })
        .then(setStream)
        .catch(() => setStream(null))
    }
  }, [currentCamDeviceId, isCamOn])

  // SAFETY: the session ref is set on mount, and onClose is always passed
  // (see the props comment).
  const handleClose = () => {
    videoRoomSession.current.leave()
    onClose()
  }

  const handleGotoMeeting = () => {
    onClose()
    gotoMeeting()
  }

  const handleGotoSettings = () => {
    onClose()
    gotoSettings(openJoinCallModal)
  }

  return (
    _react2.default.createElement(_JoinCall2.default, {
      // SAFETY: only rendered while open, with isOpen passed (see above).
      isOpen: isOpen ,
      onClose: handleClose,
      roomName: roomName,
      roomLink: roomLink,
      onRoomShare: onRoomShare,
      onRoomLinkCopy: onRoomLinkCopy,
      isMicOn: isMicOn,
      isCamOn: isCamOn,
      isCamCycleAvailable: isCamCycleAvailable,
      onCycleCam: _actions2.default.cycleCam,
      onToggleMic: _actions2.default.toggleMic,
      onToggleCam: _actions2.default.toggleCam,
      stream: stream,
      gotoMeeting: handleGotoMeeting,
      gotoSettings: handleGotoSettings,
      isBrowserCompatible: isBrowserCompatible,
      arePermsGranted: arePermsGranted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}
    )
  )
})

exports. default = JoinCallModalContainer
